export function hiddenSpecializations() {
  $(document).on('click', '.hidden-specializations-toggle', (e) => {
    const $t = $(e.currentTarget);
    const $next = $t.next();
    $next.toggleClass('show');

    if ($next.is('.show')) {
      setTimeout(() => {
        $(document).bind('click.hidden-specializations-types', (d) => {
          if (
            $(d.target).closest('.hidden-specializations')
              .length === 0
          ) {
            $next.removeClass('show');
            $(document).unbind('click.hidden-specializations-types');
          }
        });
      }, 100);
    } else {
      $(document).unbind('click.hidden-specializations-types');
    }
  });
}
